import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=d6334dd2&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"
import style0 from "@/css/shop.css?vue&type=style&index=0&id=d6334dd2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6334dd2",
  null
  
)

export default component.exports